import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import {CardContainer, Notification, Loading, Input, Validator, Button, ConfirmDialog} from 'components/common/uiKit';

import {LessonApi} from 'services/network/api';
import * as RouteService from 'services/route'
import {convertDigitsToStandard} from 'services/converts/numbers';


class LessonSetting extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            loading: false,
            title: '',
            priority: 0,
            submitLoading: false,
            deleteConfirmDialog: false,
            deleteConfirmLoading: false
        };

        this.validator = Validator(props.locale.abbreviation);
    }

    componentDidMount() {
        this.getParams();
    }

    getParams() {
        const qs = RouteService.QueryStringService.getQyeryStrings();
        if (!qs && !qs.id) {
            Notification('error', 'WrongParams');
            const {history} = this.props;
            history.goBack();
        }

        const {id} = qs;
        this.setState({id},
            () => {
                this.loadData();
            });
    }

    loadData() {
        const {id} = this.state;
        if (!id)
            Notification('error', 'WrongParams');
        else {
            this.setState({loading: true});
            LessonApi.GetAdminLesson(id)
                .then(res => {
                    if (res && res.status == 200) {
                        const {title, priority} = res.data;
                        this.setState({title, priority});
                    }
                }).finally(()=>{
                this.setState({loading: false});
            });
        }
    }

    handleInputChange = name => event => {
        this.setState({[name]: convertDigitsToStandard(event.target.value)});
    };

    handleSubmitOnClick = () => {
        let validationResult = this.validator.allValid();

        if (validationResult) {
            this.setState({submitLoading: true});

            const {id, title, priority} = this.state;
            const model = {id: parseInt(id), title, priority: parseInt(priority)};
            LessonApi.Update(model)
                .then(res => {
                    if (res && res.status == 200) {
                        Notification('success', 'Succeed');
                    }
                }).finally(() => {
                this.setState({submitLoading: false});
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
            Notification('error', 'WrongData');
            this.setState({submitLoading: false});
        }
    };

    handleDeleteOnClick = () => {
        this.setState({deleteConfirmDialog: true});
    };

    handleCancelOnClick = () => {
        const {history} = this.props;
        history.goBack();
    };

    handleConfirmDelete = () => {
        const {id} = this.state;
        if (id) {
            this.setState({deleteConfirmLoading: true});

            LessonApi.Delete(id)
                .then(res => {
                    if (res && res.status == 200) {
                        Notification('success', 'Succeed');

                        const {history} = this.props;
                        history.goBack();
                        history.goBack();
                    }
                }).finally(() => {
                this.setState({deleteConfirmLoading: false, deleteConfirmDialog: false});
            });
        }
    };

    handleCancelDelete = () => {
        this.setState({deleteConfirmDialog: false});
    };

    render() {
        const {loading} = this.state;

        if (loading)
            return <Loading/>;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Lesson.Setting;

        const {title, priority, submitLoading, deleteConfirmDialog, deleteConfirmLoading} = this.state;

        return (
            <>
                <CardContainer>
                    <div>
                        <Input label={pageTranslates.Title} placeHolder={pageTranslates.Title} value={title}
                               onChange={this.handleInputChange('title')}/>
                        {this.validator.message(pageTranslates.Title, title, 'required|min:3')}
                    </div>
                    <div>
                        <Input label={pageTranslates.Priority} placeHolder={pageTranslates.Priority} value={priority}
                               onChange={this.handleInputChange('priority')} type='tel'/>
                    </div>

                    <div>
                        <Button full type='primary' onClick={this.handleSubmitOnClick} loading={submitLoading}>
                            {pageTranslates.Submit}
                        </Button>
                        <Button full type='danger' onClick={this.handleDeleteOnClick}>
                            {pageTranslates.Delete}
                        </Button>
                        <Button full type='secondary' onClick={this.handleCancelOnClick}>
                            {pageTranslates.Cancel}
                        </Button>
                    </div>
                </CardContainer>

                <ConfirmDialog open={deleteConfirmDialog} title={pageTranslates.DeleteConfirmDialog.Title}
                               content={pageTranslates.DeleteConfirmDialog.Content}
                               onAgree={this.handleConfirmDelete} onCancel={this.handleCancelDelete}
                               agreeLoading={deleteConfirmLoading}/>
            </>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(LessonSetting));

